import { render } from "./VideoScriptGenerate.vue?vue&type=template&id=015dc62a"
import script from "./VideoScriptGenerate.vue?vue&type=script&lang=js"
export * from "./VideoScriptGenerate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__